import { AxiosError } from "axios";
var axios = require('axios');
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.common['X-Simfoni-Retail-Internal'] = true;
axios.defaults.headers.common['X-No-Log'] = !process.env.MIX_APP_LOG;
export { axios, AxiosError };
